import styled, { css } from 'styled-components';

const indentValue = 25;

export const ActionItem = styled.div`
  background: #fff;
  border-radius: 8px;
  border: 1px solid #dddddd;
  display: grid;
  grid-template-columns: 1fr 6rem;
  grid-column-gap: 0.6rem;
  justify-content: space-between;
  align-items: flex-start;
  color: ${(props) => props.theme.color.base};
  padding: 0.5rem 1rem;
  margin-bottom: 10px;
  margin-left: auto;
  width: 100%;
  max-width: ${(props) =>
    props.indentLevel
      ? `calc(100% - (${indentValue}px * ${props.indentLevel}))`
      : '100%'};
`;
ActionItem.displayName = 'ActionItem';

export const ActionItemLabel = styled.p`
  line-height: normal;
  word-break: break-word;
  align-self: center;
`;
ActionItemLabel.displayName = 'ActionItemLabel';

export const ActionItemButton = styled.button`
  ${({ theme, disabled }) => css`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-family: ${theme.fontFamily};
    text-decoration: none;
    background: ${theme.color.primary};
    color: var(--primary-color-contrast, #ffffff);
    font-size: 0.8rem;
    padding: 6px 12px;
    cursor: pointer;
    border-radius: 25px;
    border: transparent;
    height: 26px;

    &:focus-visible {
      border-color: #fff;
      box-shadow: 0 0 0 2px ${theme.color.secondary};
    }

    i {
      position: relative;
      left: -10px;
      top: -10px;
    }

    ${disabled &&
    css`
      background-color: var(--pd-disabled-button-bg-color);
      pointer-events: none;
      cursor: auto;
    `}
  `}
`;
export const Pending = styled.div``;
